module.exports = __webpack_public_path__ + "images/emoji/melon.c583e324d866faa3e61e.png";